import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import ApiService from "@/service/api.service";
import Lodash from "@/plugins/lodash";
import Toasted from "vue-toasted";
import VueProgressBar from "vue-progressbar";
import "@/styles/app.scss";

var moment = require('moment')
window.moment = moment

Vue.config.productionTip = false;
Vue.use(Lodash);
Vue.use(VueProgressBar, {
    color: "#3490dc",
    failedColor: "#f44336",
    thickness: "5px",
    transition: {
        speed: "0.2s",
        opacity: "0.6s",
        termination: 300
    },
    autoRevert: true,
    location: "top",
    inverse: false
});
Vue.use(Toasted, {
    position: "top-right",
    duration: 5000,
    action: [
        {
            text: "Închide",
            onClick: (e, toastObject) => {
                toastObject.goAway(0);
            },
            class: "close-toasted"
        }
    ],
    type: "default",
    theme: "outline"
});

ApiService.init();
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
